export enum Scale {
  CURRENCY = 100,
  CURRENCY_9 = 1_000_000_000,
  PERCENT_5 = 5,
  PERCENT_9 = 9,
  PERCENT_4 = 4,
}
